module.exports = __webpack_public_path__ + "img/4x UHF-PS1.af2688f8.svg";